import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/google-plus-square': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M400 32H48C21.5 32 0 53.5 0 80V432C0 458.5 21.5 480 48 480H400C426.5 480 448 458.5 448 432V80C448 53.5 426.5 32 400 32zM164 356C108.7 356 64 311.3 64 256S108.7 156 164 156C191 156 213.5 165.8 231 182.2L203.9 208.3C196.5 201.2 183.6 192.9 164.1 192.9 130 192.9 102.2 221.1 102.2 256.1 102.2 291 130 319.3 164.1 319.3 203.7 319.3 218.5 290.8 220.9 276.2H164V241.8H258.4C259.4 246.8 260 251.9 260 258.4 260 315.5 221.7 356 164 356zM384 274.2H355V303.2H325.8V274.2H296.8V245H325.8V216H355V245H384V274.2z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/google-plus-square.js
// module id = 2io2
// module chunks = 144